import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  InvitationWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { invitationsKeys } from "../invitations.utils"

export type UseInvitationsParams = QueryParamsDto

/**
 * Organization-specific hook for fetching organization invitations
 * Can only be used in mimber-organization app
 * The organization context is automatically handled by ServerContext
 */
export const useInvitations = (
  params?: UseInvitationsParams,
  options?: UseQueryOptions<ResponseDto<InvitationWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<InvitationWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useInvitations")

  const { server } = useServerContext()

  return useQuery({
    queryKey: invitationsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<InvitationWithRelationsDto[]>
      >(buildQueryString("invitations", params))
      return response.data
    },
    staleTime: 1 * 60 * 1000, // Consider invitations data fresh for 1 minute
    ...options,
  })
}
